<button (click)="buttonClick($event)"  #myButton pButton class="{{'width100'+' '+ classToadd}}"
    [ngClass]="{'add_flex_gap': isNgContentAdded}" [label]="label" [disabled]="isBtnDisable" [icon]="iconDtls?.name"
    [type]="buttonType"
    [iconPos]="iconDtls?.position" [title]="tooltipText?tooltipText:''">
    <ng-content></ng-content>
</button>